var $ = require('jquery');
require('slick-carousel');

// default
$('.dd-icon-tabs__content-item--1').addClass('is-active');
$('.dd-icon-tabs__tab--1').addClass('is-active');

// slider
$('.dd-slider-product').slick({
    dots: true,
    arrows: false,
    speed: 200,
    fade: true,
    autoplay: true,
    slidesToShow: 1,
    infinite: true,
    lazyLoad: 'progressive'
  })

  // $('.dd-slider-product').each(function() {
  //     var currentSliderProduct = $(this);


  //     currentSliderProduct.slick({
  //       dots: true,
  //       arrows: false,
  //       speed: 200,
  //       fade: true,
  //       autoplay: true,
  //       slidesToShow: 1,
  //       infinite: true,
  //       lazyLoad: 'progressive'
  //   })
  // });


// Navigation
$('.dd-icon-tabs__tabs li').each(function () {
  let $self = $(this);

  $self.on('click', function (event) {
    let $id = $(this).attr("data-tab");

    var screenWidth = jQuery(window).width();
    if (screenWidth <= 800) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".dd-icon-tabs__contents").offset().top - 130
      }, 1000);
    }


    // Marker active
    $('.dd-icon-tabs__tabs li').removeClass('is-active');
    $('.dd-icon-tabs__tab--' + $id).addClass('is-active');

    // Content Active
    $('.dd-icon-tabs__content-item').removeClass('is-active');
    $('.dd-icon-tabs__content-item--' + $id).addClass('is-active');

  });

});

